import { render } from "./AuthenticationUrl.vue?vue&type=template&id=94a1ce42&scoped=true"
import script from "./AuthenticationUrl.vue?vue&type=script&lang=js"
export * from "./AuthenticationUrl.vue?vue&type=script&lang=js"

import "./AuthenticationUrl.vue?vue&type=style&index=0&id=94a1ce42&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94a1ce42"]])

export default __exports__